import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import Auth from "../auth";
import RouteFallback from "../components/RouteFallback";
import Login from "../pages/Login";

const MainLayout = lazy(() => import("../components/MainLayout"));
const MainMenu = lazy(() => import("../pages/Home/MainMenu.jsx"));
const FleetMap = lazy(() => import("../pages/FleetMap"));
const LiveStream = lazy(() => import("../pages/LiveStream"));
const EventCenter = lazy(() => import("../pages/EventCenter"));
const EventDetail = lazy(() => import("../pages/EventCenter/EventDetail.jsx"));
const PlaybackNew = lazy(() => import("../pages/Playback/PlaybackNew.jsx"));
const PlaybackHistory = lazy(() => import("../pages/Playback/PlaybackHistory.jsx"));
const PlaybackDetail = lazy(() => import("../pages/Playback/PlaybackDetail.jsx"));
const Settings = lazy(() => import("../pages/Settings"));
const PeriodicReport = lazy(() => import("../pages/PeriodicReport"));
const Notifications = lazy(() => import("../pages/Notifications"));
const ChangePassword = lazy(() => import("../pages/ChangePassword"));
// UI/UX 全域設定展示頁：不放側邊欄、免登入，僅供開發對照（見 docs/ui-guidelines.md）
const UiDemo = lazy(() => import("../pages/UiDemo"));

function AuthedShell({ children }) {
  return (
    <Auth>
      <Suspense fallback={<RouteFallback />}>{children}</Suspense>
    </Auth>
  );
}

export default function Router() {
  const element = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    {
      path: "/menu",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [{ index: true, element: <MainMenu /> }],
    },
    {
      path: "/fleet",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [
        { index: true, element: <FleetMap /> },
        { path: "live", element: <LiveStream /> },
      ],
    },
    {
      path: "/events",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [
        { index: true, element: <EventCenter /> },
        { path: ":id", element: <EventDetail /> },
      ],
    },
    {
      path: "/playback",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [
        { index: true, element: <PlaybackNew /> },
        { path: "history", element: <PlaybackHistory /> },
        { path: "detail/:requestID", element: <PlaybackDetail /> },
      ],
    },
    {
      path: "/settings",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [{ index: true, element: <Settings /> }],
    },
    {
      path: "/reports",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [{ index: true, element: <PeriodicReport /> }],
    },
    {
      // 入口在帳號面板（AccountPanel）
      path: "/account/password",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [{ index: true, element: <ChangePassword /> }],
    },
    {
      // Tab Bar 已拿掉通知入口，但這條路由**不可刪**：使用者手機通知匣裡的舊推播
      // url 仍是 /notifications，點了要進得來（後端改深連結後，新推播才會導 /events/:id）
      path: "/notifications",
      element: (
        <AuthedShell>
          <MainLayout />
        </AuthedShell>
      ),
      children: [{ index: true, element: <Notifications /> }],
    },
    {
      path: "/ui-demo",
      element: (
        <Suspense fallback={<RouteFallback />}>
          <UiDemo />
        </Suspense>
      ),
    },
    { path: "*", element: <Login /> },
  ]);
  return element;
}
